import { Box, Typography, styled } from "@mui/material";
import format from "date-fns/format";
import type { PrescriptionSeverity } from "../interfaces";
import {
  PrescriptionDocumentType,
  PrescriptionStatus,
  PrescriptionStatusChipActionMapper,
  PrescriptionStatusChipSeverityMapper,
  PrescriptionStatusChipTitleMapper,
  CompoundedPrescriptionStatusChipTitleMapper,
} from "../interfaces";
import { CardInfoRow } from "../screens/PrescriptionValidation/styles";

type PrescriptionSeverityObj = { severity: PrescriptionSeverity };

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "status",
})<PrescriptionSeverityObj>(({ theme, severity }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  padding: "8px 16px",
  width: "100%",
  background: theme.palette[severity].light,
}));

const InfoContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "severity",
})<PrescriptionSeverityObj>(({ theme, severity }) => ({
  fontWeight: 600,
  color: theme.palette[severity].main,
}));

const InfoText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

type Props = {
  code: string;
  status: PrescriptionStatus;
  date?: number;
  isCompoundedPrescription?: boolean;
  type?: string;
};

export const PrescriptionStatusChip: React.FC<Props> = ({
  code,
  status,
  date,
  isCompoundedPrescription,
  type,
}) => {
  const prescriptionSeverity = PrescriptionStatusChipSeverityMapper[status];

  const getPresticptionStatusChipTitle = (
    status: PrescriptionStatus,
    isCompoundedPrescription?: boolean,
    type?: string,
  ) => {
    if (isCompoundedPrescription) {
      return CompoundedPrescriptionStatusChipTitleMapper[status];
    }

    if (type === PrescriptionDocumentType.HELD && status === PrescriptionStatus.ISSUED) {
      return "Receta por retener";
    }

    return PrescriptionStatusChipTitleMapper[status];
  };

  return (
    <Container severity={prescriptionSeverity}>
      <Title severity={prescriptionSeverity}>
        {getPresticptionStatusChipTitle(status, isCompoundedPrescription, type)}
      </Title>

      <InfoContainer>
        {status !== PrescriptionStatus.ISSUED && date && (
          <CardInfoRow>
            <InfoText>
              {`Fecha ${PrescriptionStatusChipActionMapper[status]}: `}
              {format(date, "dd/MM/yyyy HH:mm:ss")}
            </InfoText>
          </CardInfoRow>
        )}
        {status !== PrescriptionStatus.CANCELED && (
          <CardInfoRow>
            <InfoText>Código verificación: {code}</InfoText>
          </CardInfoRow>
        )}
      </InfoContainer>
    </Container>
  );
};
